/**
 * balance-terraforming.ts — terraforming balance constants (MFix4.3,
 * PLANETS §2.5 + tech-tree.json Terraforming / Advanced Terraforming).
 *
 * v1 lock 2026-04-21:
 *   - Cost: 10 000 Minerals + 100 Fuel (Exotics deferred to v2).
 *   - Duration: 6 000 ticks (≈ 10 min at 1× speed).
 *   - Tech gating: 'Terraforming' (L4) for uninhabited targets,
 *     'Advanced Terraforming' (L6) for owned-inhabited targets.
 *   - Target biome: Gaia only (other biome targets defer to v3M10
 *     balance pass when a target-biome picker UI lands).
 */

/**
 * Ticks for a terraform to complete. v3M10 balance-pass tunable.
 *
 * v3M10.1: migrated to state.balanceData.terraforming.durationTicks.
 */

/**
 * Minerals spent to start a terraform.
 *
 * v3M10.1: migrated to state.balanceData.terraforming.mineralsCost.
 */

/**
 * Fuel spent to start a terraform.
 *
 * v3M10.1: migrated to state.balanceData.terraforming.fuelCost.
 */

/** Tech name gating uninhabited-planet terraforming via a Coloniser. */
export const TERRAFORMING_TECH = 'Terraforming';

/** Tech name gating owned-planet terraforming (no ship required). */
export const ADVANCED_TERRAFORMING_TECH = 'Advanced Terraforming';
